import { useState,useEffect } from "react";
import MainHeader from "../../Components/MainHeader/MainHeader";
import axios from "axios";

function ForgetPassword(props){

  const [emailSent,setEmailSent]=useState(false); 
  const [email,setEmail]=useState('');
  const [otp,setOtp]=useState();
  const [passwod,setPassword]=useState('');
  const [repassword,setRepassword]=useState('');
  
  const [user,setuser]=useState('');

 //////////////////////

 const [countdown, setCountdown] = useState(180);

 useEffect(() => {
   // Set up an interval to decrease the countdown by 1 every second
   const countdownInterval = setInterval(() => {
    setCountdown(countdown => {
      if (countdown === 0) {
        clearInterval(countdownInterval);
        return countdown;
      } else {
        return countdown - 1;
      }
    });
  }, 1000);

   // Clean up the interval when the component unmounts
   return () => {
     clearInterval(countdownInterval);
   };
 }, [emailSent]); // run the effect only once (on mount)

 // Calculate the minutes and seconds remaining in the countdown
 const minutes = Math.floor(countdown / 60);
 const seconds = countdown % 60;

//////////////////////
  const handleEmailsent=(e)=>{
    e.preventDefault();
     axios({
        method:'POST',
        data:{
          email:email,
        },
        withCredentials:true,
        url:'https://localhost:9000/forgetpassword'
      })
      .then((res)=>{
          console.log(res.data);  //data: "Success Autheticated"
          if(res.data==="user found"){
            console.log("Saving....");
            setEmailSent(!emailSent); 
            setCountdown(180);
          }
          else{
            setuser(res.data); 
          }
          // console.log(res.data.Access);
      }
      )
  }
  const handleResetpassword=(e)=>{
     //will send password, before this validate timestamp and id 
     // generated for the above
     console.log("reset wla click");
     e.preventDefault();
     axios({
        method:'POST',
        data:{
          email:email,
          otp:otp,
          password:passwod,
          countdown:countdown

        },
        withCredentials:true,
        url:'https://localhost:9000/setpassword'
      })
      .then((res)=>{
          console.log(res.data);  //data: "Success Autheticated"
          if(res.data==="Password Updated Successfully"){
             props.nav('/');
            // console.log("Saving....");
            // setEmailSent(!emailSent); 
            // setCountdown(180);
          }
          else{
            setuser(res.data); 
          }
          // console.log(res.data.Access);
      }
      )
  }

    return <div>
        <MainHeader profileVisiblilty={false}/>
        {emailSent && (<section className="bg-gray-50 dark:bg-gray-900">
  <div className="flex flex-col items-center justify-center px-6 py-4 mx-auto  lg:pt-20">
      <div className="w-full p-6 bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md dark:bg-gray-800 dark:border-gray-700 sm:p-8">
          <h2 className="mb-1 text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
              Change Password
          </h2>
          <form className="mt-4 space-y-4 lg:mt-5 md:space-y-5" onSubmit={handleResetpassword}>
              <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Enter OTP</label>
                  <input type="number" value={otp} onChange={(e)=>setOtp(e.target.value)} placeholder="xxxxxx" className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required=""/>
              </div>
              <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">New Password</label>
                  <input type="password" value={passwod} onChange={(e)=>setPassword(e.target.value)}  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required=""/>
              </div>
              
              {/* <div className="flex items-start">
              </div> */}
              
            <button type="submit" disabled={(countdown)?false:true} className="w-full text-white bg-[#2563eb] hover:bg-[#1d4ed8] focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Reset passwod</button>
              { countdown !== 0 &&<h6>{minutes}:{seconds < 10 ? '0' : ''}{seconds} </h6>}
              { countdown === 0 && <p>Times up!</p>}
              { countdown === 0 &&
                 <button type="button"  className="text-white bg-blue-800 hover:bg-blue-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-full text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700">Login</button>
              }
              <h6>{user}</h6>
          </form>
      </div>
  </div>
</section>)}
{!emailSent && (<section className="bg-gray-50 dark:bg-gray-900">
  <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto lg:pt-20">
      <div className="w-full p-6 bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md dark:bg-gray-800 dark:border-gray-700 sm:p-8">
          <h2 className="mb-1 text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
              Enter your Registered Email Id
          </h2>
          <form className="mt-4 space-y-4 lg:mt-5 md:space-y-5" onSubmit={handleEmailsent}>
              <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Your Email</label>
                  <input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} name="email" id="password" placeholder="Type..." className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required=""/>
              </div>
              <div className="flex items-start">
              </div>
              <button type="submit" className="w-full text-white bg-[#2563eb] hover:bg-[#1d4ed8] focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Reset passwod</button>
              <h6>{user}</h6>
          </form>
      </div>
  </div>
</section>)}
    </div>
}

export default ForgetPassword;